import script from "./CollapsibleContractorDetailCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollapsibleContractorDetailCard.vue?vue&type=script&lang=ts&setup=true"

import "./CollapsibleContractorDetailCard.vue?vue&type=style&index=0&id=afec81e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afec81e6"]])

export default __exports__